
import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

interface LineItem {
  id: string;
  title?: string;
}

export const useLineItemDelete = (refetch: () => void) => {
  const [itemToDelete, setItemToDelete] = useState<LineItem | null>(null);

  const handleDelete = async (id: string) => {
    try {
      const { error } = await supabase
        .from('internal_line_items')
        .delete()
        .eq('id', id);

      if (error) throw error;
      toast.success('Line item deleted successfully');
      setItemToDelete(null);
      refetch();
    } catch (error) {
      toast.error('Failed to delete line item');
    }
  };

  return {
    itemToDelete,
    setItemToDelete,
    handleDelete
  };
};
